import { render } from "./PurchaseOrderDetail.vue?vue&type=template&id=782707ef&scoped=true&ts=true"
import script from "./PurchaseOrderDetail.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrderDetail.vue?vue&type=script&lang=ts"

import "./PurchaseOrderDetail.vue?vue&type=style&index=0&id=782707ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782707ef"]])

export default __exports__